import axios from 'axios';
import {
  memoize,
} from 'lodash/fp';

import store from '@/store';
import router from '@/router';

const url = window.API_URL;

const getClient = memoize(() => axios.create({
  baseURL: `${url}/api/v1`,
}));

const getFrontendHelperClient = memoize(() => axios.create({
  baseURL: `${url}/frontend-helper`,
}));

export default {
  get client() {
    return getClient();
  },
  get frontendHelperClient() {
    return getFrontendHelperClient();
  },
  get authHeader() {
    const token = store.state.user.token || '';
    return `Bearer ${token}`;
  },
  get versionHeader() {
    return window.VERSION_NUMBER || '';
  },
  get backendVersionHeader() {
    if (window.SITE_CONFIG) {
      return window.SITE_CONFIG.backend_version;
    }
    return '';
  },
  get pathHeader() {
    let path = '';
    if (router && router.app && router.app._route) { // eslint-disable-line
      path = router.app._route.fullPath; // eslint-disable-line
    } else {
      path = window.location.hash && window.location.hash.length > 0
        ? window.location.hash.substring(1) : window.location.pathname;
    }
    return path;
  },
  get authHeaderSimple() {
    const user = localStorage.getItem('admin_user');
    return user;
  },
  get authParameter() {
    const user = localStorage.getItem('admin_user');
    if (user) {
      const parts = user.split(':');
      const u = window.btoa(parts[0]);
      const p = window.btoa(parts[1]);
      return `${u}:${p}`;
    }
    return '';
  },
  get authSimpleParameter() {
    const user = localStorage.getItem('admin_user');
    if (user) {
      return user;
    }
    return '';
  },
  get langHeader() {
    return localStorage.getItem('language') || (window.SITE_CONFIG ? window.SITE_CONFIG.languages.default : 'sv');
  },
  get onsiteParameter() {
    if (store.state.isOnSite) {
      return '&onsite=1';
    }
    return '';
  },
  addLanguage(path) {
    let urlpath = path;
    if (path.indexOf('?') === -1) {
      urlpath = `${urlpath}?lang=${this.langHeader}`;
    } else {
      urlpath = `${urlpath}&lang=${this.langHeader}`;
    }
    urlpath = `${urlpath}${this.onsiteParameter}`;
    return urlpath;
  },
  async get(path, params = {}) {
    return (await this.client.get(this.addLanguage(path), {
      params,
      headers: {
        Authorization: this.authHeader,
        'X-Authorization-Simple': this.authHeaderSimple,
        'X-Path': this.pathHeader,
        'X-Version': this.versionHeader,
        'X-B-version': this.backendVersionHeader,
        // 'Accept-Language': this.langHeader,
      },
    })).data;
  },
  async post(path, params = {}) {
    return (await this.client.post(this.addLanguage(path), {
      params,
    }, {
      headers: {
        Authorization: this.authHeader,
        'X-Authorization-Simple': this.authHeaderSimple,
        'X-Path': this.pathHeader,
        'X-Version': this.versionHeader,
        'X-B-version': this.backendVersionHeader,
      },
    })).data;
  },
  async postFile(path, params = {}) {
    return (await this.client.post(this.addLanguage(path), params, {
      headers: {
        Authorization: this.authHeader,
        'X-Authorization-Simple': this.authHeaderSimple,
        'X-Path': this.pathHeader,
        'X-Version': this.versionHeader,
        'X-B-version': this.backendVersionHeader,
        'Content-Type': 'multipart/form-data',
      },
    })).data;
  },
  async frontendHelper(path, params = {}) {
    return (await this.frontendHelperClient.post(path, {
      params,
    }, {
      headers: {
        Authorization: this.authHeader,
        'X-Authorization-Simple': this.authHeaderSimple,
        'X-Path': this.pathHeader,
        'X-Version': this.versionHeader,
        'X-B-version': this.backendVersionHeader,
      },
    })).data;
  },
  async getRaw(path, params = {}) {
    return (await this.client.get(this.addLanguage(path), {
      params,
      headers: {
        Authorization: this.authHeader,
        'X-Authorization-Simple': this.authHeaderSimple,
        'X-Path': this.pathHeader,
        'X-Version': this.versionHeader,
        'X-B-version': this.backendVersionHeader,
      },
    })).data;
  },
  getUrl(path) {
    const urlLocal = window.API_URL;
    const baseURL = `${urlLocal}/api/v1`;
    return `${baseURL}${path}`;
  },
};



// WEBPACK FOOTER //
// ./src/classes/API.js